<template>
  <section>
    <div class="input-tag">
      <el-tag
        v-for="(tag, index) in selectTagList"
        :key="index"
        size="small"
        closable
        @close="delTag(tag)">
        {{tag.name_language['zh-HK']}}
        {{tag.name_language['en-US']}}
      </el-tag>
      <v-input
        ref="input"
        v-model="current"
        @focus="handleFocus"></v-input>
    </div>

    <ul
      v-show="tagListShow"
      class="list">
      <template v-for="(tag, i) in tagListTemp">
        <li
          v-show="!tagId.includes(tag.id)"
          :key="tag.id"
          @click="tagClick(i)">
          {{tag.name_language['zh-HK']}}
          {{tag.name_language['en-US']}}
        </li>
      </template>
      <li
        class="add_tag"
        @click="addTag">
        <span class="icon">
          <font-awesome-icon icon="plus"></font-awesome-icon>
        </span>
        New Tag
      </li>
    </ul>

    <tag-dialog
      ref="tag-dialog"
      @success="handleSuccess"></tag-dialog>
  </section>
</template>

<script>
import { getTagList } from '@/api/news'
import TagDialog from './dialog/tag-dialog.vue'
export default {
  name: 'InputTag',
  components:{
    TagDialog
  },
  props:{
    tagIds:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: '',
      tagList: [],  //服务器获取的tag list
      tagListTemp: [],  //显示的tag list
      selectTagList: [],
      tagListShow: false,
      tagId: [],
    }
  },
  watch:{
    current:{
      handler(val){
        if(val){
          // 返回搜索列表
          this.tagListTemp = this.tagList.filter(tag => {
            let name = tag.name_language['en-US'] + tag.name_language['zh-HK']
            return name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
        }else{
          this.tagListTemp = JSON.parse(JSON.stringify(this.tagList))
        }
      }
    },

    tagIds:{
      immediate: true,
      handler(val){
        this.tagId = JSON.parse(JSON.stringify(val))
        this.tagList.map((tag, i) => {
          if(this.tagId.includes(tag.id)){
            this.selectTagList.push(this.tagList[i])
          }
        })
      }
    }
  },
  mounted(){
    this.network().getTagList()
  },
  methods: {
    delTag(tag){
      let i = this.selectTagList.indexOf(tag)
      this.selectTagList.splice(i, 1)
      this.tagId.splice(i, 1)
    },

    handleFocus() {
      this.tagListShow = true
    },

    tagClick(index){
      this.selectTagList.push(this.tagList[index])
      this.tagId.push(this.tagList[index].id)
    },

    addTag(){
      this.$refs['tag-dialog'].changeDialog()
    },

    handleSuccess(){
      this.network().getTagList()
    },

    getTagId(){
      this.$emit('getTag',this.tagId)
    },

    network(){
      return {
        getTagList: async () => {
          const { data } = await getTagList()
          this.tagList = data
          this.tagListTemp = JSON.parse(JSON.stringify(this.tagList))
        },
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.input-tag {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #E1E4E8;
  border-radius: 6px;
  box-shadow: inset 0px 1px 2px rgba(27, 31, 35, 0.075);
  background: #fff;
  .el-tag{
    margin: 3px;
    border-radius: 100px;
    word-break: break-all;
    white-space: normal;
    height: auto;
  }
  .el-input{
    flex: 1 0 auto;
    width: auto;
    margin: 0 8px;
    display: flex;
  }
  /deep/ .el-input > input{
    border: 0;
    background: transparent;
    padding: 0;
    flex: 1 0 auto;
    width: 100px;
  }
  .btn {
    margin: 0 5px 3px 0;
    padding: 4px 5px;
    box-shadow: 0 0 4px;
  }
}
.list{
  width: 100%;
  background: #fff;
  border-radius: 6px;
  margin-top: 13px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 2;
  li{
    padding: 7px 32px 8px 32px;
    list-style: none;
    cursor: pointer;
    word-break: break-word;
  }
  .add_tag{
    color: #0366D6;
    .icon{
      margin-right: 9px;
    }
  }
  li + li{
    border-top: 1px solid #EAECEF;
  }
}
</style>
